export const adminAuthService = {
  /**
   * Vérifie si l'utilisateur est admin via son rôle Firestore (lu dans AuthContext)
   */
  isAdmin(user) {
    return user?.role === 'admin';
  },

  /**
   * Vérifie si l'email est admin — conservé pour rétrocompatibilité,
   * délègue au rôle Firestore via l'objet user
   */
  isAdminEmail(email, user) {
    return user?.role === 'admin';
  },
};
